// src/utils/legendUtils.js

// 1. TEKSTÜRÜ RAKAMA ÇEVİRME
export const getTextureCode = (textureStr) => {
  if (!textureStr) return "";
  const tex = textureStr.split(" ")[0].trim();

  const textureMap = {
    S: "1 ",
    LS: "2 ",
    LfS: "2 ",
    SL: "3 ",
    fSL: "3 ",
    SfL: "3 ",
    SiL: "4 ",
    L: "4 ",
    vfSL: "4 ",
    SCL: "5 ",
    SiCL: "5 ",
    CL: "5 ",
    SC: "6 ",
    SiC: "6 ",
    C: "6 ",
  };

  return textureMap[tex] || "";
};

// 2. EĞİMİ HARFE ÇEVİRME
export const getSlopeCode = (slopeStr) => {
  if (!slopeStr) return "";
  const slopeMap = {
    "0-2": "A ",
    "2-4": "B1 ",
    "4-6": "B2 ",
    "6-8": "C1 ",
    "8-10": "C2 ",
    "10-12": "C3 ",
    "12-14": "D1 ",
    "14-16": "D2 ",
    "16-18": "D3 ",
    "18-20": "D4 ",
    "20-30": "E ",
    "30-45": "F ",
    "45+": "G ",
  };
  return slopeMap[slopeStr] || "";
};

// 3. DERİNLİĞİ RAKAMA ÇEVİRME
export const getDepthCode = (depthVal) => {
  // depthVal artık doğrudan cm cinsinden bir sayı. (kok_gel_derinlik parametresi kaldırıldı)
  const cm = parseFloat(depthVal);

  if (isNaN(cm)) return "";

  if (cm >= 91) return "d1";
  if (cm >= 51 && cm <= 90) return "d2";
  if (cm >= 21 && cm <= 50) return "d3";
  if (cm >= 0 && cm <= 20) return "d4";

  return "";
};

// 4. ARAZİ KULLANIMI İÇİN HARF KODU (SAĞ KISIM İÇİN EKLENDİ)

export const getLandUseCode = (useStr) => {
  if (!useStr) return "K";
  const s = useStr.toLowerCase();

  if (s.includes("nadassız")) return "N";
  if (s.includes("kuru")) return "K";
  if (s.includes("sulanan")) return "Sy";
  if (s.includes("sulu")) return "S";
  if (s.includes("çayır")) return "Ç";
  if (s.includes("bahçe")) return "B";
  if (s.includes("bağ")) return "Ba";
  if (s.includes("mera")) return "M";
  if (s.includes("terk")) return "T";
  if (s.includes("funda") || s.includes("çalı")) return "F";
  if (s.includes("hali") || s.includes("boş")) return "H";
  if (s.includes("özel")) return "Z";
  if (s.includes("orman")) return "O";
  if (s.includes("ırmak")) return "IY";

  return "K";
};

// 5. ANA HESAPLAMA FONKSİYONU
export const calculateLegend = (data) => {
  // =========================================================
  // 1) SOL KISIM: Profil Grubu (Örn: XI)
  // =========================================================
  const leftCode = data.profilgrup || "I";

  // =========================================================
  // 2) SAĞ KISIM: Arazi Kullanım Şekli (Örn: K)
  // =========================================================
  const rightCode = getLandUseCode(data.arazi_kullanim_sinif);

  // =========================================================
  // 3) ÜST KISIM (PAY): Seri Alt. Üst. Eğim Derinlik Drenaj Tuzluluk
  // =========================================================
  const seri =
    data.seri_kodu + " " ||
    (data.toprak_serisi ? data.toprak_serisi.substring(0, 3) : "");
  const topTexRaw =
    data.horizons && data.horizons.length > 0 ? data.horizons[0].tekstur : "";
  const topTexCode = getTextureCode(topTexRaw);

  let botTexRaw = topTexRaw;
  if (data.horizons && data.horizons.length > 1) {
    botTexRaw = data.horizons[data.horizons.length - 1].tekstur;
  }
  const botTexCode = getTextureCode(botTexRaw);

  const slopeCode = getSlopeCode(data.egim_yuzde);
  const depthCode = getDepthCode(data.tesirli_derinlik);

  let drainCode = "";
  if (data.tabii_drenaj && !data.tabii_drenaj.includes("İyi")) {
    // K, F1, F2, F3'ü net olarak çeker
    if (data.tabii_drenaj.includes("F1")) drainCode = "F1 ";
    else if (data.tabii_drenaj.includes("F2")) drainCode = "F2 ";
    else if (data.tabii_drenaj.includes("F3")) drainCode = "F3 ";
    else if (data.tabii_drenaj.includes("K")) drainCode = "K ";
  } else if (data.tabii_drenaj && data.tabii_drenaj.includes("İyi")) {
    drainCode = "I ";
  }

  let saltCode = "";
  if (data.tuzluluk) {
    if (data.tuzluluk.includes("Tuzsuz") || data.tuzluluk.includes("1"))
      saltCode = "1";
    else if (data.tuzluluk.includes("Hafif") || data.tuzluluk.includes("2"))
      saltCode = "2";
    else if (data.tuzluluk.includes("Orta") || data.tuzluluk.includes("3"))
      saltCode = "3";
    else if (data.tuzluluk.includes("Çok") || data.tuzluluk.includes("6"))
      saltCode = "6";
  }

  const topString =
    `${seri}${botTexCode}${topTexCode}${slopeCode}${depthCode}${drainCode}${saltCode}`
      .replace(/\s+/g, " ")
      .trim();

  // =========================================================
  // 4) ALT KISIM (PAYDA): Kısıtlayıcı Fazlar
  // =========================================================
  let phases = [];

  if (
    data.taslilik &&
    data.taslilik.includes("T") &&
    !data.taslilik.includes("Taşsız")
  ) {
    phases.push(data.taslilik.split("-")[0].trim());
  }

  if (
    data.kayalilik &&
    data.kayalilik.includes("R") &&
    !data.kayalilik.includes("R0")
  ) {
    let rCode = data.kayalilik.split("-")[0].trim();
    if (rCode === "R4") rCode = "R6 ";
    phases.push(rCode);
  }

  if (data.su_erozyon_derecesi) {
    const eroNum = data.su_erozyon_derecesi.charAt(0);
    if (eroNum === "1") phases.push("E1 ");
    else if (eroNum === "2") phases.push("E2 ");
    else if (eroNum === "3") phases.push("E3 ");
    else if (eroNum === "4") phases.push("E6 ");
  }

  // HATA TAMAMEN ÇÖZÜLDÜ: Regex kullanılmadan doğrudan içindeki koda bakılır. (Sadece F1, F2, F3 yazar)
  if (data.sel_basmasi && data.sel_basmasi !== "Yok") {
    if (data.sel_basmasi.includes("F1")) phases.push("F1 ");
    else if (data.sel_basmasi.includes("F2")) phases.push("F2 ");
    else if (data.sel_basmasi.includes("F3")) phases.push("F3 ");
  }

  // --- YENİ EKLENENLER ---

  // 5. Rüzgar Erozyonu / Aşındırma (R - Wind Erosion)
  // Doküman Örnek: R1, R2, R3, R6 [cite: 77-85]
  if (data.ruzgar_asinma && !data.ruzgar_asinma.toLowerCase().includes("yok")) {
    // Örn: "R1 - Hafif..." ise boşluktan bölüp ilkini alıyoruz.
    const wCode = data.ruzgar_asinma.split(" ")[0].trim() + " ";
    phases.push(wCode);
  }

  // 6. Rüzgar Erozyonu / Yığılma (Y - Deposition)
  // Doküman Örnek: Y1, Y2, Y3, Y6 [cite: 86-91]
  if (
    data.ruzgar_yigilma &&
    !data.ruzgar_yigilma.toLowerCase().includes("yok")
  ) {
    // Örn: "Y1 - 5 cm..." ise boşluktan bölüp ilkini alıyoruz.
    const yCode = data.ruzgar_yigilma.split(" ")[0].trim();
    phases.push(yCode);
  }

  const bottomString = phases.join("");

  return {
    leftCode,
    topString,
    bottomString, // Artık R ve Y kodlarını da içeriyor (Örn: T1 E2 R1 Y1)
    rightCode,

    // UI çipleri için ham veriler
    seri,
    topTexCode,
    botTexCode,
    slopeCode,
    depthCode,
    drainCode,
    saltCode,
  };
};

// =============================================================================
// 6. SERI-FAZ HARITALAMA BIRIMI
// =============================================================================
// Kaynak: SERI FAZ HARITASI (1:25.000) "SERI + FAZ Duzeyinde Haritalama Lejanti"
//
//     Gb 6.B d1 t2 r2 F1 3 X1 B2
//     |  | |  |  |  |  |  | |  +- Bor         B1..B4
//     |  | |  |  |  |  |  | +---- Alkalilik   X1..X4
//     |  | |  |  |  |  |  +------ Tuzluluk    1..4
//     |  | |  |  |  |  +--------- Drenaj      I, K, F1, F2, F3
//     |  | |  |  |  +------------ Kayalilik   r0, r1, r2, r3, r6
//     |  | |  |  +--------------- Taslilik    t1..t3
//     |  | |  +------------------ Derinlik    d1..d4
//     |  | +--------------------- Egim        A..F
//     |  +----------------------- Tekstur     1..6
//     +-------------------------- Toprak serisi
//
// Verisi olmayan unsur yazilmaz (yerine uydurma deger konmaz).
// =============================================================================

// TEKSTUR SINIFLARI: 1 cok kaba ... 6 ince
const SERI_FAZ_TEKSTUR = {
  S: "1",
  LS: "2",
  LFS: "2",
  FLS: "2",
  VFLS: "2",
  SL: "3",
  SFL: "3",
  FSL: "3",
  SIL: "4",
  L: "4",
  SI: "4",
  VFSL: "4",
  SCL: "5",
  SICL: "5",
  CL: "5",
  SC: "6",
  SIC: "6",
  C: "6",
};

export const seriFazTeksturKodu = (tekstur) => {
  if (!tekstur) return "";
  const ilk = String(tekstur)
    .trim()
    .split(/[\s(]/)[0]
    .toLocaleUpperCase("tr-TR")
    .replace(/İ/g, "I");
  return SERI_FAZ_TEKSTUR[ilk] || "";
};

// EGIM: A 0-2 | B 2,1-6 | C 6,1-12 | D 12,1-20 | E 20,1-30 | F 30,1+
// Araliklarda ust sinir esas alinir ("4-6" -> B, "6-8" -> C).
export const seriFazEgimKodu = (egim) => {
  if (egim === undefined || egim === null || String(egim).trim() === "")
    return "";
  const sayilar = (String(egim).match(/\d+(?:[.,]\d+)?/g) || []).map((n) =>
    parseFloat(n.replace(",", ".")),
  );
  if (sayilar.length === 0) return "";
  const ust = Math.max(...sayilar);
  if (ust <= 2) return "A";
  if (ust <= 6) return "B";
  if (ust <= 12) return "C";
  if (ust <= 20) return "D";
  if (ust <= 30) return "E";
  return "F";
};

// TOPRAK DERINLIGI: d1 91+ | d2 51-90 | d3 21-50 | d4 0-20
export const seriFazDerinlikKodu = (cm) => {
  const d = parseFloat(String(cm ?? "").replace(",", "."));
  if (isNaN(d)) return "";
  if (d > 90) return "d1";
  if (d > 50) return "d2";
  if (d > 20) return "d3";
  return "d4";
};

// Tas / kaya kodu: "T2 - Orta Taşlı" -> "t2" ; "R4 - Pek Çok Kayalı" -> "r6"
const seriFazFazKodu = (deger, harf) => {
  const s = String(deger ?? "")
    .trim()
    .toLocaleUpperCase("tr-TR");
  const m = s.match(new RegExp("^" + harf + "\\s*(\\d)"));
  if (!m) return "";
  let rakam = m[1];
  // Seri-faz lejantinda pek cok kayali (%51-90) "r6" olarak yazilir.
  if (harf === "R" && rakam === "4") rakam = "6";
  return harf.toLowerCase() + rakam;
};

// DOGAL DRENAJ: I | K | F1 | F2 | F3
const seriFazDrenajKodu = (deger) => {
  const m = String(deger ?? "").match(/\(([^()]*)\)\s*$/);
  const kod = (m ? m[1] : "").trim().toLocaleUpperCase("tr-TR");
  if (kod === "İ" || kod === "I") return "I";
  if (kod === "K") return "K";
  if (/^F[1-3]$/.test(kod)) return kod;
  return "";
};

// TUZLULUK: 1 tuzsuz | 2 hafif | 3 orta | 4 cok tuzlu
// (Formdaki "Cok Tuzlu (6)" AKK olcegidir; seri-faz'da 4 yazilir.)
const seriFazTuzKodu = (deger) => {
  const s = String(deger ?? "").toLocaleLowerCase("tr-TR");
  if (!s.trim()) return "";
  if (s.includes("tuzsuz")) return "1";
  if (s.includes("hafif")) return "2";
  if (s.includes("orta")) return "3";
  if (s.includes("çok")) return "4";
  const m = s.match(/\d/);
  if (!m) return "";
  return m[0] === "6" ? "4" : m[0];
};

// ALKALILIK: X1 0-14,9 | X2 15-29,9 | X3 30-39,9 | X4 40+
const seriFazAlkaliKodu = (deger) => {
  const s = String(deger ?? "").trim();
  if (!s) return "";
  const x = s.toLocaleUpperCase("tr-TR").match(/X\s*([1-4])/);
  if (x) return "X" + x[1];
  const k = s.toLocaleLowerCase("tr-TR");
  if (k.includes("çok")) return "X4";
  if (k.includes("fazla")) return "X3";
  if (k.includes("orta")) return "X2";
  if (k.includes("yok")) return "X1";
  return "";
};

// BOR: B1 borsuz | B2 hafif | B3 orta | B4 yuksek
const seriFazBorKodu = (deger) => {
  const s = String(deger ?? "").trim();
  if (!s) return "";
  const b = s.toLocaleUpperCase("tr-TR").match(/B\s*([1-4])/);
  if (b) return "B" + b[1];
  const k = s.toLocaleLowerCase("tr-TR");
  if (k.includes("borsuz")) return "B1";
  if (k.includes("hafif")) return "B2";
  if (k.includes("orta")) return "B3";
  if (k.includes("yüksek")) return "B4";
  return "";
};

// data: profil bicimli veri (sonda icin alanlar izah cetvelinde eslenir)
//   seri_kodu, tesirli_derinlik, egim_yuzde, tabii_drenaj, taslilik,
//   kayalilik, tuzluluk, alkalilik, bor, horizons[0].tekstur
export const seriFazBirimi = (data = {}) => {
  const seri = String(data.seri_kodu ?? "").trim();
  const tekstur = seriFazTeksturKodu(data.horizons?.[0]?.tekstur);
  const egim = seriFazEgimKodu(data.egim_yuzde);
  // Tekstur ve egim nokta ile bitisik yazilir: "6.B"
  const teksturEgim = tekstur && egim ? `${tekstur}.${egim}` : tekstur || egim;

  return [
    seri,
    teksturEgim,
    seriFazDerinlikKodu(data.tesirli_derinlik),
    seriFazFazKodu(data.taslilik, "T"),
    seriFazFazKodu(data.kayalilik, "R"),
    seriFazDrenajKodu(data.tabii_drenaj),
    seriFazTuzKodu(data.tuzluluk),
    seriFazAlkaliKodu(data.alkalilik),
    seriFazBorKodu(data.bor),
  ]
    .filter(Boolean)
    .join(" ");
};
